import FetchHelper from '../helpers/fetch_helper';
import WindowHelper from '../helpers/window_helper';

const DocumentsDispatcher = {
  async documentsDelete({ proposalId, customerId, legalDocuments, cancellationReason }) {
    try {
      if (customerId !== null && customerId !== undefined) {
        await this.dispatch({ type: 'deleteFinancingRequest', data: { customerId, cancellationReason } });
        this.dispatch({ type: 'endPolling', data: 'fetchFinancingRequest' });
      }
      if (legalDocuments !== null && legalDocuments !== undefined && legalDocuments.length > 0) {
        await this.dispatch({ type: 'legalDocumentsDelete', data: { proposalId } });
      }
      let proposal = await this.dispatch({ type: 'fetchProposal', data: proposalId });

      let customer = await this.dispatch({ type: 'fetchCustomer', data: customerId });

      if (proposal.financingRequestId) {
        console.error('WHAT IT HAS A FRID?!~');
      }
      if (!customer) {
        console.error('WHAT NO CUSTOMER?!~');
      }

      return proposal;
    } catch (error) {
      this.dispatch({ type: 'handleRequestError', data: { error, defaultErrorMessage: 'Could not cancel documents' } });
      throw error;
    }
  },

  /**
   * NOTE : DO NOT USE THIS FUNCTION DIRECTLY TO CANCEL DOCS
   * always use documentsDelete function
   *
   * @param proposalId
   * @returns {Promise.<void>}
   */
  async legalDocumentsDelete({ proposalId }) {
    try {
      await FetchHelper.fetchJson(`proposals/${proposalId}/legal-documents`, {
        method: 'delete',
      });

      await this.dispatch({ type: 'refreshFinancingMethods' });
      this.setStoreVal('legalDocuments', []);
    } catch (error) {
      this.dispatch({ type: 'handleRequestError', data: { error, defaultErrorMessage: 'Could not cancel documents' } });
      throw error;
    }
  },

  async signDocuments({ proposal: { id }, customer: { cemail, cfirstname, clastname, caddress1 }, financingMethodId }) {
    let promise;
    try {
      if (cemail && cfirstname && clastname && caddress1) {
        this.dispatch({ type: 'setRoute', data: `/proposal/${id}/generating-documents` });
        promise = await this.dispatch({
          type: 'openHomeownerPacket',
          data: {
            proposalId: id,
            email: cemail,
            financingMethodId,
          },
        });
      } else
        this.dispatch({
          type: 'setErrorMessages',
          data: ['Please provide homeowner name, address and email before signing documents.'],
        });
      return promise;
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'Could not get documents to sign' },
      });
      return undefined;
    }
  },

  async openHomeownerPacket({ proposalId, financingMethodId }) {
    let legalDocuments = this.getStoreVal('legalDocuments');
    let legalDocumentsResponse;
    if (!legalDocuments || legalDocuments.length === 0) {
      try {
        legalDocumentsResponse = await FetchHelper.fetchJson(
          `proposals/${proposalId}/financing-methods/${financingMethodId}/legal-documents`,
          { method: 'post' }
        );
        legalDocuments = legalDocumentsResponse.results;
        this.setStoreVal('legalDocuments', legalDocuments);
      } catch (error) {
        this.dispatch({
          type: 'handleRequestError',
          data: { error, defaultErrorMessage: 'Could not get documents to sign' },
        });
        throw error;
      }
    }
    return legalDocumentsResponse;
  },

  async openProposalDocument({ proposalId, proposalDocument }) {
    try {
      const documentPromise = FetchHelper.fetchJson(
        `proposals/${proposalId}/legal-documents/${proposalDocument.id}/bytes`,
        {
          method: 'GET',
          isBytes: true,
        }
      );
      WindowHelper.openFile(documentPromise);
    } catch (error) {
      this.dispatch({ type: 'handleRequestError', data: { error, defaultErrorMessage: 'Could not view document' } });
    }
  },

  async signHomeownerPacket({ proposalId, customer }) {
    try {
      let recipients = [{ role: 'HomeownerPrimarySigner' }];
      if (customer.csecondaryfirstname && customer.csecondarylastname) {
        recipients.push({ role: 'HomeownerSecondarySigner' });
      }

      const response = await FetchHelper.fetchJson(`proposals/${proposalId}/signatures/in-person`, {
        method: 'post',
        body: {
          recipients,
          documentsToSend: [
            {
              type: 'packet_homeowner',
            },
          ],
        },
      });

      response.results[0].signers.forEach((signer) => {
        const urlToOpen = signer.url;
        if (!urlToOpen) throw new Error();
        WindowHelper.open(urlToOpen);
      });
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'Could not create DocuSign link' },
      });
    }
  },

  async sendDocumentsForSignatureViaEmail({ proposalId, customer }) {
    try {
      let recipients = [{ role: 'HomeownerPrimarySigner' }];
      if (customer.csecondaryemail) {
        recipients.push({ role: 'HomeownerSecondarySigner' });
      }
      await FetchHelper.fetchJson(`proposals/${proposalId}/signatures/by-email`, {
        method: 'post',
        body: {
          recipients,
          documentsToSend: [
            {
              type: 'packet_homeowner',
            },
          ],
        },
      });
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'Could not send documents for signature via email' },
      });
    }
  },
};

export default DocumentsDispatcher;
